export default __webpack_public_path__ + "static/media/austin-distel.cbdfbac3.jpg";